import type { Flujo } from "./flujos.api";

/** Los adjuntos de un intermediario del bot viven en la mitad que recibe. */
export function idParaAdjuntos(flujo: Flujo | null, par?: Flujo | null): number | string | null {
  if (!flujo) return null;
  if (!par || Number(flujo.pairedId) !== Number(par.id)) return flujo.id;
  // Conservar acceso a adjuntos históricos guardados en la mitad abierta.
  if (flujo.imagenes?.length) return flujo.id;
  if (par.imagenes?.length) return par.id;
  return flujo.rolDeAlojaFacil === "recibe" ? flujo.id : par.id;
}
